'use client';
import { _ as _object_without_properties_loose, a as _extends } from './cc-CWi2JB6O.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import 'react';
import { Command as Command$1 } from 'cmdk';
import { SearchIcon } from 'lucide-react';
import { cn } from '@repo/lib/utils';
import { Dialog, DialogHeader, DialogTitle, DialogDescription, DialogContent } from './dialog.js';

function Command(_0) {
    let { className } = _0, props = _object_without_properties_loose(_0, [
        "className"
    ]);
    return /*#__PURE__*/ jsx(Command$1, _extends({
        "data-slot": "command",
        className: cn("bg-popover text-popover-foreground flex h-full w-full flex-col overflow-hidden rounded-md", className)
    }, props));
}
function CommandDialog(_0) {
    let { title = "Command Palette", description = "Search for a command to run...", children, className, showCloseButton = true } = _0, props = _object_without_properties_loose(_0, [
        "title",
        "description",
        "children",
        "className",
        "showCloseButton"
    ]);
    return /*#__PURE__*/ jsxs(Dialog, _extends({}, props, {
        children: [
            /*#__PURE__*/ jsxs(DialogHeader, {
                className: "sr-only",
                children: [
                    /*#__PURE__*/ jsx(DialogTitle, {
                        children: title
                    }),
                    /*#__PURE__*/ jsx(DialogDescription, {
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ jsx(DialogContent, {
                className: cn("overflow-hidden p-0", className),
                showCloseButton: showCloseButton,
                children: /*#__PURE__*/ jsx(Command, {
                    className: "[&_[cmdk-group-heading]]:text-muted-foreground **:data-[slot=command-input-wrapper]:h-12 [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group]]:px-2 [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5",
                    children: children
                })
            })
        ]
    }));
}
function CommandInput(_0) {
    let { className } = _0, props = _object_without_properties_loose(_0, [
        "className"
    ]);
    return /*#__PURE__*/ jsxs("div", {
        "data-slot": "command-input-wrapper",
        className: "flex h-9 items-center gap-2 border-b px-3",
        children: [
            /*#__PURE__*/ jsx(SearchIcon, {
                className: "size-4 shrink-0 opacity-50"
            }),
            /*#__PURE__*/ jsx(Command$1.Input, _extends({
                "data-slot": "command-input",
                className: cn("placeholder:text-muted-foreground flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-hidden disabled:cursor-not-allowed disabled:opacity-50", className)
            }, props))
        ]
    });
}
function CommandList(_0) {
    let { className } = _0, props = _object_without_properties_loose(_0, [
        "className"
    ]);
    return /*#__PURE__*/ jsx(Command$1.List, _extends({
        "data-slot": "command-list",
        className: cn("max-h-75 scroll-py-1 overflow-x-hidden overflow-y-auto", className)
    }, props));
}
function CommandEmpty(_0) {
    let props = _extends({}, _0);
    return /*#__PURE__*/ jsx(Command$1.Empty, _extends({
        "data-slot": "command-empty",
        className: "py-6 text-center text-sm"
    }, props));
}
function CommandGroup(_0) {
    let { className } = _0, props = _object_without_properties_loose(_0, [
        "className"
    ]);
    return /*#__PURE__*/ jsx(Command$1.Group, _extends({
        "data-slot": "command-group",
        className: cn("text-foreground **:[[cmdk-group-heading]]:text-muted-foreground overflow-hidden p-1 **:[[cmdk-group-heading]]:px-2 **:[[cmdk-group-heading]]:py-1.5 **:[[cmdk-group-heading]]:text-xs **:[[cmdk-group-heading]]:font-medium", className)
    }, props));
}
function CommandSeparator(_0) {
    let { className } = _0, props = _object_without_properties_loose(_0, [
        "className"
    ]);
    return /*#__PURE__*/ jsx(Command$1.Separator, _extends({
        "data-slot": "command-separator",
        className: cn("bg-border -mx-1 h-px", className)
    }, props));
}
function CommandItem(_0) {
    let { className } = _0, props = _object_without_properties_loose(_0, [
        "className"
    ]);
    return /*#__PURE__*/ jsx(Command$1.Item, _extends({
        "data-slot": "command-item",
        className: cn("data-[selected=true]:bg-accent data-[selected=true]:text-accent-foreground [&_svg:not([class*='text-'])]:text-muted-foreground relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className)
    }, props));
}
function CommandShortcut(_0) {
    let { className } = _0, props = _object_without_properties_loose(_0, [
        "className"
    ]);
    return /*#__PURE__*/ jsx("span", _extends({
        "data-slot": "command-shortcut",
        className: cn("text-muted-foreground ml-auto text-xs tracking-widest", className)
    }, props));
}

export { Command, CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandSeparator, CommandShortcut };
